import CampusStipendBrochure from "./CampusStipendBrochure"

export default function CampusBrochureAmity() {
    return <CampusStipendBrochure college="Amity Lucknow" eligibility="2nd-year B.Tech CS" campus="amity" />
}
